<template>
  <v-flex class="widgets" lg6>
    <v-card>
      <v-card-title>
        <div class="headline">{{ widgetTitle }}</div>
        <div class="grey--text">Click on the different coloured segments to view the corresponding data in your quote report.</div>
      </v-card-title>
      <GChart
        ref="gChart"
        type="BarChart"
        :data="graphData"
        :resizeDebounce="500"
        :events="chartEvents"
        :options="chartOptions"></GChart>
      <v-card-actions>
        <dialog-filter-config fc-key="quote_val_per_rep" :widget-title="widgetTitle"></dialog-filter-config>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import BaseWidget from '../base-widget';
import DialogFilterConfig from '../dialog-filter';
import jsonata from 'jsonata';
import { GChart } from 'vue-google-charts';
import Vue from "vue";

export default {
  name: "quote-value-per-rep",
  extends: BaseWidget,
  data() {
    return {
      widgetTitle: 'Quote Value Per Rep',
      exampleData: {},
      graphData: [],
      chartOptions: {
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: '90%' },
        height: 400
      },
      chartEvents: {
        select: () => {
          const chartParams = this.$refs.gChart.chartObject.getSelection();
          console.log(chartParams);
        }
      }
    }
  },
  methods: {
    filterData() {
      try {
        const filteredData = {
          "Entries": jsonata(`
          Entries
           {
              originator: {
                  "months": {
                      quote_year & '.' & quote_month: $formatNumber($sum(nett_amount), "#0.00;(#0.00)")
                  },
                  "total": $formatNumber($sum(nett_amount), "#0.00;(#0.00)")
              }
          }
          `).evaluate(this.dataCollection)
        };
        this.exampleData = filteredData;
        const data = [];
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const months = this.monthRange(this.range[0], this.range[1])
        const monthsDisplay = [];

        months.forEach((val) => {
          const dateParts = val.split('.');
          const date = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1);
          monthsDisplay.push(monthNames[date.getMonth()] + ' ' + date.getFullYear());
        });

        let axisX = ['Amount in Rands']
        axisX = axisX.concat(monthsDisplay);
        data.push(axisX);

        Object.keys(filteredData.Entries).forEach((key) => {
          const reps = [];
          reps.push(key);

          const monthlyValues = [];
          const monthlyKeys = Object.keys(filteredData.Entries[key].months);
          monthlyKeys.sort((a, b) => {
            return parseFloat(a) - parseFloat(b);
          });
          monthlyKeys.forEach((val) => {
            monthlyValues[val] = filteredData.Entries[key].months[val];
          });

          months.forEach((monthKey, idx) => {
            if (typeof monthlyValues[monthKey] !== "undefined") {
              reps.push(parseFloat(monthlyValues[monthKey]));
            } else {
              reps.push(0);
            }
          });
          data.push(reps);
        });

        this.graphData = data;

      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {

  },
  created() {
    Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Widget.php', {
      params: {
        a: 'quotes',
        token: 'dlBWlbFDgR5A0eearsSZBouOH9I9282I',
        params: {
          manufacturer: this.$store.getters.objAuthorize.manufacturer,
          date_from: this.range[0],
          date_to: this.range[1]
        }
      }
    }).then((response) => {
      this.graphData = JSON.parse(response.bodyText);
    });
  },
  components: {
    DialogFilterConfig,
    GChart
  }
}
</script>


